import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import HomepageLight from "./pages/HomepageLight";
import "./App.scss";
import PaperDetails from "./pages/PaperDetails";

// Create a Theme Context
export const ThemeContext = React.createContext();

function App() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Initialize from localStorage or default to false
    const saved = localStorage.getItem("theme-mode");
    return saved ? saved === "dark" : false;
  });

  // Update document body class and localStorage whenever theme changes
  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("dark");
      localStorage.setItem("theme-mode", "dark");
    } else {
      document.body.classList.remove("dark");
      localStorage.setItem("theme-mode", "light");
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      <BrowserRouter>
        <Switch>
          <Route path="/" exact>
            <HomepageLight />
          </Route>
          <Route path="/papers/paper-details/:id/:title" component={PaperDetails} />
        </Switch>
      </BrowserRouter>
    </ThemeContext.Provider>
  );
}

export default App;
